type TicketTierLimits = {
  status: string
  availableFrom?: string | null
  availableUntil?: string | null
  ticketsRemaining?: number | null
  minPerOrder?: number | null
  maxPerOrder?: number | null
}

export const ticketQuantityLimits = (
  tier: TicketTierLimits,
  now = Date.now()
) => {
  const min = tier.minPerOrder ?? 1
  const limits = [tier.maxPerOrder, tier.ticketsRemaining].filter(
    (limit): limit is number => limit != null
  )
  const max = limits.length ? Math.min(...limits) : 100
  const available =
    tier.status === 'active' &&
    (!tier.availableFrom || new Date(tier.availableFrom).getTime() <= now) &&
    (!tier.availableUntil || new Date(tier.availableUntil).getTime() >= now) &&
    max >= min
  return { min, max, available }
}

export const clampTicketQuantity = (
  quantity: number,
  tier: TicketTierLimits
) => {
  const { min, max, available } = ticketQuantityLimits(tier)
  if (!available || !Number.isFinite(quantity) || quantity < min) return 0
  return Math.min(Math.floor(quantity), max)
}
